<!-- src/components/ProfitCalculator/NormalCalculator.vue -->
<template>
  <div>
    <el-form-item label="卖出价">
      <el-input-number
        :model-value="sellPrice"
        :min="0"
        :step="0.1"
        @update:model-value="handleSellPriceChange">
        <template #append>元</template>
      </el-input-number>
    </el-form-item>

    <el-form-item label="成本价">
      <el-input-number
        :model-value="costPrice2"
        :min="0"
        :step="0.1"
        @update:model-value="handleCostPriceChange">
        <template #append>元</template>
      </el-input-number>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'NormalCalculator',
  props: {
    sellPrice: {
      type: Number,
      default: 150
    },
    costPrice2: {
      type: Number,
      default: 100
    }
  },
  emits: ['update:sellPrice', 'update:costPrice2'],
  methods: {
    handleSellPriceChange(value) {
      this.$emit('update:sellPrice', value);
    },

    handleCostPriceChange(value) {
      this.$emit('update:costPrice2', value);
    }
  }
}
</script>
